import { Button } from "@photo-booth/ui/button";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@photo-booth/ui/popover";
import { analyticsClick } from "@/lib/analytics/props";
import { useAllowedUserAgent } from "@/hooks/useAllowedUserAgent";
/**
 * Discreet help trigger shown only to download-restricted users
 * (Google app / Android WebView), rendered under the result actions.
 * Opens a popover with browser-switch and long-press save instructions.
 */
export const DownloadHelpPopover: React.FC = () => {
  const { isDownloadRestricted, browserHint, openInBrowserProps } =
    useAllowedUserAgent();

  if (!isDownloadRestricted || !openInBrowserProps) {
    return null;
  }

  const isChrome = browserHint === "chrome";
  const openBrowserLabel = isChrome ? "เปิดใน Chrome" : "เปิดใน Safari";

  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button
          variant="ghost"
          size="sm"
          className="text-vintage-red underline underline-offset-4 text-sm min-h-[44px] mt-4"
        >
          Can’t download?
        </Button>
      </PopoverTrigger>
      <PopoverContent
        side="top"
        align="center"
        className="w-72 px-0 pt-4 pb-0 space-y-3 bg-natural-white text-vintage-black"
      >
        <div className="px-4 text-center">
          <p className="text-sm font-family-kanit">
          1. กดค้างที่ภาพเเล้วบันทึก
        </p>

        <p className="text-sm font-family-kanit text-center">หรือ</p>

        <p className="text-sm font-family-kanit">
          2. ดึงเว็บไปเปิดที่ {openBrowserLabel} เเล้วกดดาวน์โหลด
        </p>
        </div>
        <Button
          className="w-full rounded-t-none mb-0 min-h-[44px] font-family-kanit backdrop:blur-sm bg-vintage-red text-natural-white hover:bg-vintage-red/90"
          onClick={openInBrowserProps.onClick}
          {...analyticsClick({
            event: "download-help-open-browser",
            feature: "ui",
            location: window.location.pathname,
          })}
        >
          {openBrowserLabel}
        </Button>
      </PopoverContent>
    </Popover>
  );
};
